import {
  authorizedGetCall,
  authorizedPostCall,
  authorizedPutCall,
  authorizedDeleteCall,
} from "./APIsService";

export const getBusinessUsers = (
  category = null,
  businessSubscriptionType = null,
  search = null
) => {
  return new Promise((resolve, reject) => {
    let url = `business-users?`;
    if (category) url += `category=${category}&`;
    if (businessSubscriptionType)
      url += `businessSubscriptionType=${businessSubscriptionType}&`;
    if (search) url += `searchQuery=${encodeURIComponent(search)}&`;

    // Remove trailing & if present
    url = url.replace(/&$/, "");

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addBusinessUser = (data) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`business-users`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editBusinessUser = (id, data) => {
  return new Promise((resolve, reject) => {
    authorizedPutCall(`business-users/${id}`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteBusinessUser = (id) => {
  return new Promise((resolve, reject) => {
    authorizedDeleteCall(`business-users/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getUserHistory = (search = null) => {
  return new Promise((resolve, reject) => {
    let url = `user-history`;
    if (search) {
      url += `?searchQuery=${encodeURIComponent(search)}`;
    }

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getRegularUsers = (search = null) => {
  return new Promise((resolve, reject) => {
    let url = `regular-users`;
    if (search) {
      url += `?searchQuery=${encodeURIComponent(search)}`;
    }

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const changeRegularUserStatus = (id, status) => {
  return new Promise((resolve, reject) => {
    authorizedPutCall(`regular-users/${id}`, { status })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
